import { treeData, nodeContents } from '../../mock/mockData';

// Build a flat searchable index of every object in the directory.
function buildIndex() {
  const idx = [];
  const nameMap = {};
  const walk = (node) => {
    nameMap[node.id] = node.name;
    if (node.children) node.children.forEach(walk);
  };
  walk(treeData);

  Object.keys(nodeContents).forEach((parentId) => {
    const parentName = nameMap[parentId] || parentId;
    nodeContents[parentId].forEach((item) => {
      idx.push({
        id: item.id,
        name: item.name,
        type: item.type,
        description: item.description || '',
        parentId,
        parentName,
      });
    });
  });

  return idx;
}

export const SEARCH_INDEX = buildIndex();

export function searchAll(query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return [];
  return SEARCH_INDEX.filter((it) => {
    const hay = (it.name + ' ' + it.description + ' ' + it.type).toLowerCase();
    return hay.includes(q);
  });
}
